<template>
  <div id="app">
    <Home :data="data" :fileName="fileName" />
  </div>
</template>

<script>
import Home from './components/viewKfb/home';
import axios from "axios";

export default {
  name: 'App',
  components: {
    Home,
  },
  data() {
    return {
      data: {},
      fileName: '/data/applications/kfbio_en/storage/app/kfb/wj1.kfb',
    }
  },
  beforeMount() {
    axios.get(`/kfb/info?file=${this.fileName}`).then(res => {
      this.data = res.data;
    })
  }
}
</script>

<style lang="scss">
@import '@/assets/css/responsive';
@import '@/assets/css/main.css';
/*#app {*/
/*  font-family: Avenir, Helvetica, Arial, sans-serif;*/
/*  -webkit-font-smoothing: antialiased;*/
/*  -moz-osx-font-smoothing: grayscale;*/
/*  text-align: center;*/
/*  color: #2c3e50;*/
/*  margin-top: 60px;*/
/*}*/
html, body {
  height: 100%;
}
#app {
  //background-color: cornflowerblue;
  height: 100%;
}
.container {
  position: relative;
  width: px(1120);
  height: px(600);
  border: 1px solid #fff;
  border-radius: 40px;
  overflow: hidden;
}
</style>
